/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        $(document).foundation(); // Foundation JavaScript

        $(window).resize(function() {
          $('.pg-section').height($(window).height() - 80);
          $('.pg-section').width($(window).width());
        });

        $(function() {
          $('#toggle-menu').click(function() {
            $('#mobile-menu').toggleClass('open');
          });
        });

        //$(window).trigger('resize');

        $(function() {
          $('.scroll').click(function() {
            if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
              if (target.length) {
                $('html,body').animate({
                  scrollTop: (target.offset().top)
                }, 1000);
                return false;
              }
            }
          });
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        $(window).scroll(function() {
          if ($(this).scrollTop() > 80) { //use `this`, not `document`
              $('.breadcrumbs').css({
                  'display': 'none'
              });
          } else {
            $('.breadcrumbs').css({
                  'display': 'block'
              });
          }
        });

        $(window).scroll(function() {
          if ($(this).scrollTop() > 5) {
            $('.search-bar').addClass('hidden');
          } else {
            $('.search-bar').removeClass('hidden');
          }
        });

        $(document).ready(function(){
          if ($(this).scrollTop() > 5) {
            $('.search-bar').addClass('hidden');
          } else {
            $('.search-bar').removeClass('hidden');
          }
        });

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'litigation_finance_discovery': {
      init: function() {
        
        $('.article-tag').click (function(e) {
          e.preventDefault();
          var tag = $(this).data('tag');
          var tag_html = $(this).html();
          $('.discovery-cell.article, .tag-title').fadeOut('fast');
          $('.tag-title h6').html(tag_html);
          
          setTimeout(function(){ 
            $('.tag-title').fadeIn(700);
            $('.discovery-cell.article.' + tag).fadeIn(700);
            var target = $('.tag-title h6');
            $('html,body').animate({
              scrollTop: (target.offset().top) - 130
            }, 1000);
          }, 3000);

        });

      }
    },
    'page_id_1669': {
      init: function() {
        
        $('#calculate').click(function(){

            var revenue = $('#revenue').val();
            console.log(revenue);
            //var value = revenue * 14 * 0.018 * 0.01;
            var value = (revenue/12) * 169 * 0.5 * 0.0155;
            console.log(value);
            //var low = numeral(value * .75 * 1000000).format('0,0');
            var low = numeral( Math.round( value * .0075 * 1000000 / 1000)*1000 ).format('0,0');
            //var high = numeral(value * 1.5 * 1000000).format('0,0');
            var high = numeral( Math.round( value * 0.014 * 1000000 /1000)*1000 ).format('0,0');
            //var results = '<div class="row"><div class="small-12 columnns"><h6>Results</strong></h6><p><strong>Low end estimate (in millions): </strong> $' + low.toFixed(2) + '</p><p><strong>High end estimate (in millions)</strong> $' + high.toFixed(2) + '</p></div></div>';
            var results = '<div class="row"><div class="small-12 columnns"><p><strong>Estimated Value</strong><br>The approximate estimate of the current monetization value of your claim is between $' + low + ' and $' + high + '.</p><a data-reveal-id="contactModal" class="button rounded blue">Contact us to learn more</a></div></div>';
            $('#results').html(results).fadeIn();

        });

      }
    },
    'page_id_1730': {
      init: function() {
        
         $(document).ready(function(){$('#contactModal').foundation('reveal', 'open')}); 

      }
    }

  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
